import React from 'react';

const TermsOfServicePage = () => {
 return (
  <div>
    <iframe src="HH_TOS.pdf" width="100%" height="2000px" />
  </div>
 );
};
export default TermsOfServicePage;